import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FavoriteCardsService {

  private apiUrl = environment.apiUrl;
  showFavorites = true;

  constructor(private http: HttpClient) {
  }

  findAllByUser(page: number = 0, size: number = 9): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get(`${this.apiUrl}/favorite-cards`, {params});
  }

  saveFavoriteCardByCardId(cardId: bigint): Observable<any> {
    return this.http.post(`${this.apiUrl}/favorite-cards/cardId/${cardId}`, {});
  }

  getFavorites(ids: Array<bigint>): Observable<{ [key: string]: boolean; }> {
    const body = {
      ids: ids
    }
    return this.http.post<{ [key: string]: boolean; }>(`${this.apiUrl}/favorite-cards/favorites`, body);
  }

  deleteFavoriteCardByCurrentUserIdAndCardId(cardId: bigint): Observable<any> {
    return this.http.delete(`${this.apiUrl}/favorite-cards/cardId/${cardId}`);
  }

  deleteAllFavoriteCardsByUser(): Observable<any> {
    return this.http.delete(`${this.apiUrl}/favorite-cards/clear`);
  }
}
